<template>
    <v-col class="kanban-column">
        <transition appear name="fade-transition">
            <div class="kanban-column__header">
                <slot v-if="findSlot('header')" name="header" v-bind="{ loading }" />
            </div>
        </transition>
        <transition appear name="fade-transition">
            <v-card flat :loading="loading" class="kanban-column__boards flex-grow-1">
                <slot name="boards" v-bind="{ loading }" />
            </v-card>
        </transition>
    </v-col>
</template>

<script>
export default {
    name: 'KanbanColumn',
    props: {
        loading: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" scoped>
.v-application .kanban-column {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    width: 10%;
    margin: 0 0.5rem;
    background: var(--v-background-darken2);
    border-radius: 0.5rem 0.5rem 0 0;

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }

    @include respond-below-height(sm) {
        height: auto;
    }

    &__header {
        padding: 0.5rem 1rem 0.5rem 1rem;
    }

    &__boards {
        overflow-y: scroll;
        padding: 0.5rem 1rem 1rem 1rem;
        background: none;
    }
}
</style>
